import { clsx } from '@payaca/utilities/cvaMerge';
import React, { ComponentPropsWithoutRef, useContext, useId } from 'react';

import { FieldContext } from '../Field/Context';

export interface RadioProps extends Omit<
  ComponentPropsWithoutRef<'input'>,
  'type' | 'id' | 'name'
> {
  label?: string;
  hiddenLabel?: boolean;
}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  const { className, disabled, label, hiddenLabel = false, ...rest } = props;
  const { name } = useContext(FieldContext);
  const uId = useId();

  return (
    <div className="typography:prose flex items-center">
      <input
        ref={ref}
        id={uId}
        name={name}
        className={clsx(
          'pl-form-radio',
          className,
          disabled ? ' cursor-not-allowed' : ' cursor-pointer'
        )}
        type="radio"
        disabled={disabled}
        {...rest}
      />
      {label && (
        <label
          htmlFor={uId}
          className={clsx(
            'ms-3',
            hiddenLabel && 'sr-only',
            disabled ? ' cursor-not-allowed opacity-50' : ' cursor-pointer'
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
});

export default Radio;
